var ArrayUtils = {

    /**
     * Creates a new array with the content of specified array
     * @param  {Array} array array to copy
     * @param  {int} from Index of first element to copy. Default is 0.
     * @param  {int} to Index of last element to copy. If not specified, last index will be used.
     * @return {Array} new Array
     */
    copy: function(array, from, to) {
        if (array) {
            if (typeof from === "undefined") {
                from = 0;
            }
            if (typeof to === "undefined") {
                to = -1;
            }

            var result = [];
            var toIndex = (to == -1) ? array.length - 1 : to;
            if (from >= 0 && toIndex >= 0 && from <= toIndex) {
                for (var i = from; i <= toIndex; i++) {
                    result.push(array[i]);
                }
            }
            return result;
        }
        return null;
    },

    /**
     *  Copies the content of specified array in another array.
     * @param  {array} src     Source
     * @param  {int}   srcPos  Index of first element to copy
     * @param  {array} dest    Destination
     * @param  {int}   destPos Index of first element to insert
     * @param  {int}   length  Number of items to copy
     */
    arrayCopy: function(src, srcPos, dest, destPos, length) {
        if (srcPos <= srcPos + length) {
            for (var i = 0; i < length; i++) {
                this.insertAt(dest, src[srcPos + i], destPos + i);
            }
        }
    },

    /**
     * Appends the content of specified array in another array.
     * @param  {Array} src  Source
     * @param  {Array} dest Destination
     */
    appendArray: function(src, dest) {
        if (src && dest) {
            this.arrayCopy(src, 0, dest, dest.length, src.length);
        }
    },

    /**
     * Moves an element in an array
     * @param  {Array} array Array in which the operation will be done
     * @param  {int} from  index of the element to move
     * @param  {int} to    index where to move item
     */
    moveTo: function(array, from, to) {
        array.splice(to, 0, array.splice(from, 1)[0]);
    },

    /**
     * Moves an element in an array
     * @param  {Array} array  Array in which the operation will be done
     * @param  {object} element Element to move
     * @param  {int} to index where to move item
     */
    moveElementTo: function(array, element, to) {
        this.moveTo(array, array.indexOf(element), to);
    },

    /**
     * Insert an element in an array
     * @param  {Array} array Array in which the operation will be done
     * @param  {object} element element to insert
     * @param  {int} index index where to insert the element
     */
    insertAt: function(array, element, index) {
        array.splice(index, 0, element);
    },

    /**
     * Verifies if element is present in array
     * @param  {Array} array   Array in which the verification will be done
     * @param  {object} element element to verify
     * @return {Boolean} True is element is present, False otherwise.
     */
    containsElement: function(array, element) {
        return array.indexOf(element) >= 0;
    },

    /**
     * Deletes an element in an array
     * @param  {Array} array Array in which the operation will be done.
     * @param  {int} index index of the element to delete
     */
    deleteAt: function(array, index) {
        array.splice(index, 1);
    },

    /**
     * Deletes an element in an array
     * @param  {Array} array   Array in which the operation will be done.
     * @param  {object} element element to delete
     */
    deleteElement: function(array, element) {
        var index = array.indexOf(element);
        if (index >= 0) {
            this.deleteAt(array, index);
        }
    },

    /**
     * Removes all elements from an array
     * @param  {Array} array Array to clear
     */
    removeAll: function(array) {
        array.length = 0;
    },

    /**
     * Replaces an element in an array
     * @param  {Array} array Array in which the operation will be done.
     * @param  {object} element element to insert
     * @param  {int} index index where to place the element
     */
    replaceAt: function(array, element, index) {
        array.splice(index, 1, element);
    },

    /**
     * Swaps two elements in an array
     * @param  {Array} array Array in which the operation will be done.
     * @param  {int} index1 first element to swap
     * @param  {int} index2 second element to swap
     */
    swap: function(array, index1, index2) {
        var temp = array[index1];
        this.replaceAt(array, array[index2], index1);
        this.replaceAt(array, temp, index2);
    },

    /**
     * Swaps two elements in an array
     * @param  {Array} array Array in which the operation will be done.
     * @param  {object} element1 first element to swap
     * @param  {object} element2 second element to swap
     */
    swapElements: function(array, element1, element2) {
        this.swap(array, array.indexOf(element1), array.indexOf(element2));
    },

    /**
     * Search through a sorted array for a specified search key
     * @param  {Array} array Array containing elements
     * @param  {object} searchKey Element to search
     * @param  {int} minimum Minimum index.  If not specified, 0 is used.
     * @param  {int} maximum Maximum index.  If not specified, length of array is used.
     * @param  {function} compareFunction Function to compare items.  If not specified, greater than (>) and less than (<) operators will be used to compare items.
     * @return {int} index of found item.
     */
    binarySearch: function(array, searchKey, minimum, maximum, compareFunction) {
        if (typeof minimum === "undefined") {
            minimum = 0;
        }
        if (typeof maximum === "undefined") {
            maximum = array.length;
        }
        if (minimum == maximum) {
            return minimum;
        } else {
            var middle = minimum + ((maximum - minimum) / 2);
            middle = Math.floor(middle);
            var compareResult;
            if (typeof compareFunction !== "undefined") {
                // compare using specified compare function
                compareResult = compareFunction(searchKey, array[middle]);
            } else {
                // compare using operators                    
                compareResult = (searchKey > array[middle]) ? 1 : (searchKey < array[middle]) ? -1 : 0;
            }
            //console.info("result: " + compareResult);
            if (compareResult > 0) {
                return this.binarySearch(array, searchKey, middle + 1, maximum, compareFunction);
            } else if (compareResult < 0) {
                return this.binarySearch(array, searchKey, minimum, middle, compareFunction);
            }
            return middle;
        }
    },

    isContainingAtLeastOne(source, elements) {
        if (source && elements) {
            if (elements.length == 0) {
                return false;
            } else {
                for (var element of elements) {
                    if (source.indexOf(element) >= 0) {
                        return true;
                    }
                }
                return false;
            }
        } else {
            return false;
        }
    }
};

export default ArrayUtils;